<script setup lang="tsx">
import { ref } from "vue";
import Container from "../Container.vue";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: "#e6e6e6"
  }
);

const width = ref(0);
const height = ref(0);

function ready(controller) {
  width.value = controller.rect.width;
  height.value = controller.rect.height;
}
</script>

<template>
  <Container
    type="full"
    @ready="ready"
  >
    <!-- 不设置 width height , 自适应父元素 -->
    <svg
      :viewBox="`0 0 ${width} ${height}`"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      fill="none"
      :style="{
        display: 'block',
        transformOrigin: 'center'
      }"
    >
      <ellipse
        :cx="width * 0.5"
        :cy="height * 0.5"
        :rx="width * 0.5"
        :ry="height * 0.5"
        :fill="props.color"
      />
    </svg>
  </Container>
</template>
